import { createContext, useContext } from 'react';

import { Scene } from '../SceneLoader';

export type SceneContextType = {
  scene: Scene | null;
  projectPath: string | null;
  parseContentPath: (path: string) => string;
};

export const SceneContext = createContext<SceneContextType>({
  scene: null,
  projectPath: null,
  parseContentPath: (path) => path,
});
export const useScene = () => useContext(SceneContext);
